// CREATE ONM ACTIVITY
export const CREATE_ONM_ACTIVITY_LOADING = "CREATE_ONM_ACTIVITY_LOADING";
export const CREATE_ONM_ACTIVITY_SUCCESS = "CREATE_ONM_ACTIVITY_SUCCESS";
export const CREATE_ONM_ACTIVITY_FAILURE = "CREATE_ONM_ACTIVITY_FAILURE";
export const CREATE_ONM_ACTIVITY_RESET = "CREATE_ONM_ACTIVITY_RESET";

// GET ONM ACTIVITIES
export const GET_ONM_ACTIVITIES_LOADING = "GET_ONM_ACTIVITIES_LOADING";
export const GET_ONM_ACTIVITIES_SUCCESS = "GET_ONM_ACTIVITIES_SUCCESS";
export const GET_ONM_ACTIVITIES_FAILURE = "GET_ONM_ACTIVITIES_FAILURE";
export const GET_ONM_ACTIVITIES_RESET = "GET_ONM_ACTIVITIES_RESET";

// RESCHEDULE ACTIVITY
export const RESCHEDULE_ONM_ACTIVITY_LOADING =
  "RESCHEDULE_ONM_ACTIVITY_LOADING";
export const RESCHEDULE_ONM_ACTIVITY_SUCCESS =
  "RESCHEDULE_ONM_ACTIVITY_SUCCESS";
export const RESCHEDULE_ONM_ACTIVITY_FAILURE =
  "RESCHEDULE_ONM_ACTIVITY_FAILURE";
export const RESCHEDULE_ONM_ACTIVITY_RESET = "RESCHEDULE_ONM_ACTIVITY_RESET";

// UPDATE ACTIVITY STATUS
export const UPDATE_ONM_ACTIVITY_STATUS_LOADING =
  "UPDATE_ONM_ACTIVITY_STATUS_LOADING";
export const UPDATE_ONM_ACTIVITY_STATUS_SUCCESS =
  "UPDATE_ONM_ACTIVITY_STATUS_SUCCESS";
export const UPDATE_ONM_ACTIVITY_STATUS_FAILURE =
  "UPDATE_ONM_ACTIVITY_STATUS_FAILURE";
export const UPDATE_ONM_ACTIVITY_STATUS_RESET =
  "UPDATE_ONM_ACTIVITY_STATUS_RESET";

// GET ONM ACTIVITIES
export const GET_ONM_DOCUMENTS_LOADING = "GET_ONM_DOCUMENTS_LOADING";
export const GET_ONM_DOCUMENTS_SUCCESS = "GET_ONM_DOCUMENTS_SUCCESS";
export const GET_ONM_DOCUMENTS_FAILURE = "GET_ONM_DOCUMENTS_FAILURE";
export const GET_ONM_DOCUMENTS_RESET = "GET_ONM_DOCUMENTS_RESET";

// ADD ONM DOCUMENT
export const ADD_ONM_DOCUMENT_LOADING = "ADD_ONM_DOCUMENT_LOADING";
export const ADD_ONM_DOCUMENT_SUCCESS = "ADD_ONM_DOCUMENT_SUCCESS";
export const ADD_ONM_DOCUMENT_FAILURE = "ADD_ONM_DOCUMENT_FAILURE";
export const ADD_ONM_DOCUMENT_RESET = "ADD_ONM_DOCUMENT_RESET";

// UPDATE ONM DOCUMENT
export const UPDATE_ONM_DOCUMENT_LOADING = "UPDATE_ONM_DOCUMENT_LOADING";
export const UPDATE_ONM_DOCUMENT_SUCCESS = "UPDATE_ONM_DOCUMENT_SUCCESS";
export const UPDATE_ONM_DOCUMENT_FAILURE = "UPDATE_ONM_DOCUMENT_FAILURE";
export const UPDATE_ONM_DOCUMENT_RESET = "UPDATE_ONM_DOCUMENT_RESET";

// GET PROJECTS OVERVIEW LIST
export const GET_PROJECTS_OVERVIEW_LIST_LOADING =
  "GET_PROJECTS_OVERVIEW_LIST_LOADING";
export const GET_PROJECTS_OVERVIEW_LIST_SUCCESS =
  "GET_PROJECTS_OVERVIEW_LIST_SUCCESS";
export const GET_PROJECTS_OVERVIEW_LIST_FAILURE =
  "GET_PROJECTS_OVERVIEW_LIST_FAILURE";
export const GET_PROJECTS_OVERVIEW_LIST_RESET =
  "GET_PROJECTS_OVERVIEW_LIST_RESET";

// IS ONM ENABLED
export const IS_ONM_ENABLED_LOADING = "IS_ONM_ENABLED_LOADING";
export const IS_ONM_ENABLED_SUCCESS = "IS_ONM_ENABLED_SUCCESS";
export const IS_ONM_ENABLED_FAILURE = "IS_ONM_ENABLED_FAILURE";
